import React from "react";
import { Card, CardMedia, CardContent, Typography, Box } from "@mui/material";
import { colors } from "../../../../constants/colors";
import { coin_icons } from "../../../../assets/icons/icons";

interface CustomerCardProps {
  headerColor: string;
  headerText: string;
  imageUrl: string;
  customerName: string;
  position: string;
  department: string;
  rank: number;
  position_name: string;
  department_name: string;
}

const CustomerCard: React.FC<CustomerCardProps> = ({
  headerColor,
  headerText,
  imageUrl,
  customerName,
  position,
  department,
  rank,
  position_name,
  department_name
}) => {

  const renderRank = (rank: number) => {

    if (rank == 1) {
      return <coin_icons.CoinOne />
    } else if (rank == 2) {
      return <coin_icons.CoinTwo />
    } else if (rank == 3) {
      return <coin_icons.CoinThree />
    } else if (rank == 4) {
      return <coin_icons.CoinFour />
    }

    return <></>
  }
  return (
    <Card
      sx={{
        maxWidth: 300,
        minWidth: 300,
        borderRadius: 2,
        boxShadow: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflow: "hidden", // Ensures no overflow outside the card
      }}
    >
      {/* Header */}
      <Box
        sx={{
          backgroundColor: headerColor,
          color: "#fff",
          padding: 1,
          width: "100%",
          textAlign: "center",
          borderRadius: "4px 4px 0 0",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: "#fff",
          }}
        >
          {headerText}
        </Typography>
      </Box>

      {/* Image */}


      <Box className="flex gap-2 p-4">
        <Box>
          {renderRank(rank)}
        </Box>
        <Box>
          <CardMedia
            component="img"
            height="150"
            sx={{
              width: 150,
              height: 150,
              borderRadius: "50%",
              display: "block",
              marginTop: 2,
            }}
            image={imageUrl}
            alt="Customer image"
          />
        </Box>
        <Box width={40}></Box>
      </Box>


      {/* Content */}
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 2,
          gap: 1,
          textAlign: "center",
        }}
      >
        {/* Customer Name */}
        <Typography
          variant="h6"
          gutterBottom
          color={colors.subPrimary}
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "100%",
          }}
        >
          {customerName}
        </Typography>

        <Typography>
          {position_name || "-"}
        </Typography>
        <Typography>
          {department_name || "-"}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default CustomerCard;
